import type * as React from 'react';

export function AccessWall({ children }: { children: React.ReactNode }): React.ReactElement {
    return (
        // - outer wrapper is needed to allow the inner content to scroll yet also be centered
        // - `min-h-full` lets it grow with tall content (e.g. the trial screen on mobile) and stay
        //   scrollable from the top.
        // - `md:h-full` pins it to the viewport so the trial grid can stretch its rows evenly.
        // - `justify-content: center` may cause the content to be cut-off if its taller than the height of the container.
        // - by adding `safe`, we make it so it only centers if there's enough room, otherwise it top-aligns.
        <div className="scrollbar h-full w-full overflow-y-auto">
            <div className="flex min-h-full w-full flex-col items-center p-4 pt-16 [justify-content:safe_center] md:h-full md:p-12 md:pt-24 xl:p-20 xl:pt-36">
                {children}
            </div>
        </div>
    );
}
